import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CountryListComponent } from './country-list/country-list.component';
import { CountryCreateComponent } from './country-create/country-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: CountryListComponent,
        data: {
          title: "Country List",
          breadcrumb: "Country List"
        }
      },
      {
        path: 'create',
        component: CountryCreateComponent,
        data: {
          title: "Create Country",
          breadcrumb: "Create Country"
        }
      },
      {
        path: 'edit/:id',
        component: CountryCreateComponent,
        data: {
          title: "Edit Country",
          breadcrumb: "Edit Country"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CountryRoutingModule { }
